import { useEffect, useState } from 'react';
import { AlertType, TowerAlert } from '../../../common/Alerts';
import { useErrorQueryStringValue } from './useQueryString';

const useQueryStringAlerts = () => {
    const [alerts, setAlerts] = useState<TowerAlert[]>([]);
    const errorParam = useErrorQueryStringValue();

    useEffect(() => {
        if (errorParam === 'saml-redirect') {
            setAlerts([
                {
                    type: AlertType.error,
                    message: 'SSO login failed. Please try again or contact team@foreflight.com.',
                },
            ]);
        }
    }, []);

    return alerts;
};
export default useQueryStringAlerts;
